import * as React from 'react';
import InputRange from './InputRange';
import { GeneralSelect } from '../../../../store/action/generalActions';
import Section from '../../Section';
import './GeneralContent.css';

interface Props {
    onChange: GeneralSelect;
}

const message = `Rate your agreement with the following statements using 
                 the scale from 0 to 10 where 0 means "Do not Agree at all" 
                 and 10 means "Completely Agree."`;

const firstQuestionMessage = `When it comes to data analytics, my company 
                              MUST maintain a competitive advantage over the 
                              competition.`;
const secondQuestionMessage = `When it comes to data analytics, my company 
                               DOES maintain a competitive advantage over the competition.`;
const thirdQuestionMessage = `My company is demonstrating COMMITMENT to increase meaningful 
                              use and application of data analytics.`;

class GeneralContent extends React.Component<Props> {
    render() {
        const { onChange } = this.props;

        return (
            <Section>
                <form>
                    <p className="explanation">
                        {message}
                    </p>
                    <div>
                        <p className="general-question">{firstQuestionMessage}</p>
                        <InputRange
                            id="must"
                            onChange={onChange}
                        />
                    </div>
                    <div>
                        <p className="general-question">{secondQuestionMessage}</p>
                        <InputRange
                            id="does"
                            onChange={onChange}
                        />
                    </div>
                    <div>
                        <p className="general-question">{thirdQuestionMessage}</p>
                        <InputRange
                            id="commitment"
                            onChange={onChange}
                        />
                    </div>
                </form>
            </Section>
        );
    }
}

export default GeneralContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/general/GeneralContent.tsx